/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const AFFIRMATIVE_BUTTON = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.affirmative.button'
        defaultMessage='к выбору наград'
    />
)

export const PURCHASE_TANK = tankName => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.tankpurchase'
        defaultMessage='Получить награду «{tankName}»?'
        values={{ tankName }}
    />
)

export const PURCHASE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.purchase'
        defaultMessage='Получить'
    />
)

export const CURRENCY_TO_SPEND = currency => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.currency_to_spend'
        defaultMessage='К обмену: {currency}'
        values={{ currency }}
    />
)

export const CURRENCY_LEFT = currency => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.currency_left'
        defaultMessage='На вашем счету останется: {currency}'
        values={{ currency }}
    />
)

export const NO = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.tank.no'
        defaultMessage='Нет'
    />
)

export const CANCEL_BET_TITLE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.auction.cancel_bet.title'
        defaultMessage='Отмена ставки'
    />
)

export const CANCEL_BET_DESCRIPTION = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.auction.cancel_bet.description'
        defaultMessage='Ставка на аукционе на получение призовой машины будет отменена, боны вернутся на ваш счёт.'
    />
)

export const STYLE_VETERAN = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.info_text_style.style_veteran'
        defaultMessage='«Ветеран»'
    />
)

export const INFO_TEXT_STYLE = (style_veteran) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.info_text_style'
        defaultMessage='Данная призовая машина начисляется вместе с набором кастомизации {style_veteran}'
        values={{ style_veteran }}
    />
)

export const CANCEL_BET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.cancel_bet'
        defaultMessage='Отменить ставку'
    />
)

export const TTC_TITLE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.TTC.title'
        defaultMessage='Ключевые ТТХ:'
    />
)

export const MORE_ABOUT_TANK = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.more_about_tank'
        defaultMessage='Подробнее в Танковедении'
    />
)

export const TANK_TECH_STATS = {
    MAX_HEALTH: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.max_health'
            defaultMessage='Прочность (ед.)'
        />
    ),
    HULL_ARMORS: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.hull_armors'
            defaultMessage='Бронирование корпуса (мм)'
        />
    ),
    TURRET_ARMORS: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.turret_armors'
            defaultMessage='Бронирование башни (мм)'
        />
    ),
    DAMAGE: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.damage'
            defaultMessage='Средний урон (ед.)'
        />
    ),
    PIERCING: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.piercing'
            defaultMessage='Средняя бронепробиваемость (мм)'
        />
    ),
    GUN_RATE_CYCLE: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.gun_rate_cycle'
            defaultMessage='Скорострельность орудия (выстр/мин)'
        />
    ),
    GUN_RATE: (
        <FormattedMessage
            id='wgcwx_shop.rewards.tank.tank_tech_stats.gun_rate'
            defaultMessage='Перезарядка (полная/между/кол-во)'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/translations.jsx